// @ts-ignore
const protocol = window.location.protocol;
const hostname = window.location.hostname;

const API_PATH:string = process.env.REACT_APP_API_PATH ? process.env.REACT_APP_API_PATH : `${protocol}//${hostname}/api/`;

const BOOKING_STATE_SUBSCRIPTION_PATH:string = "/app/booking-status";

export {API_PATH, BOOKING_STATE_SUBSCRIPTION_PATH};